import React, { useRef } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import AccommodationModal from '../../components/AccomodationModal/AccommodationModal'
import Hero from '../../components/Hero/Hero'
import LoadingSpinner from '../../components/elements/LoadingSpinner'
import SiteNavigation from '../../components/SiteNavigation/SiteNavigation'
import TourActions from '../../components/TourActions/TourActions'
import TourDetails from '../../components/TourDetails/TourDetails'
import TourItinerary from '../../components/TourItinerary/TourItinerary'
import TrainsSlider from '../../components/Trains/TrainSlider';
import DealBanner from '../../components/DealBanner/DealBanner'

import { isRailBookers } from '../../configuration/brand'
import { getBrand } from '../../redux/reducers/configuration'
import {
  tourDetailsData,
  getTourDetailsLoading,
} from '../../redux/reducers/tourDetails'
import { addBrandCurrencyPrefix } from '../../utilities/currency/formatPrice'

import '../../styles/scss/views/tour-details-container.scss'

const TourDetailsContainer = () => {
  const loading = useSelector(getTourDetailsLoading)
  const tour = useSelector((state) => tourDetailsData(state))
  const brand = useSelector(getBrand)
  const trains = _.get(tour, 'data.trains', [])

  const overviewRef = useRef()
  const itineraryRef = useRef()
  const detailsRef = useRef()
  const onboardRef = useRef()

  const refs = [overviewRef, itineraryRef, detailsRef, onboardRef]

  if (loading) {
    return <LoadingSpinner />
  }

  if (!loading && !tour?.data?.id) {
    return null
  }

  return (
    <div className="tour-details-container">
      <AccommodationModal />
      <div id="tour-overview" className="tab-action-section" ref={overviewRef}></div>
      <Hero
        tourId={tour.data.id}
        brand={brand}
        backgroundImage={tour.data.heroImage}
        heroImages={tour.data.heroImages}
        discountText={_.get(tour, 'data.offer.bannerText')}
        tags={tour.data.displayDestinations}
        numCountries={tour.data.countries}
        numDays={tour.data.duration}
        // hide destinations for rail and sail
        numDestinations={tour.data.isRailAndSail ? 0 : tour.data.heroDestinationCount}
        price={addBrandCurrencyPrefix(brand, tour.data.advertisedPrice)}
        roundTripUpgradePrice={tour.data.roundTripUpgradePrice}
        softripBooking={tour.data.softripBooking}
        title={tour.data.name}
      />

      <SiteNavigation />
      <TourActions references={refs} />

      <div className={`tour-details-container__content`}>
        <div className="tour-details-container__content__tabbed">
          <div className={`tour-details-container__content__tabbed__tab tab-action-section`} id="tour-itinerary" ref={itineraryRef}>
            <TourItinerary
              description={tour.data.description}
              itinerary={tour.data.tripItinerary}
              map={tour.data.map}
              name={tour.data.name}
              isCityBreak={tour.data.isCityBreak}
              isGetaway={tour.data.isGetaway}
              isRoundtrip={tour.data.isRoundtrip}
              destinationStart={tour.data.destinationStart}
              destinationEnd={tour.data.destinationEnd}
              reverseItinerary={tour.data.reverseItinerary}
              softripBooking={tour.data.softripBooking}
              tourAccommodations={tour.data.tourAccommodations}
              tripItineraryIsEmpty={tour.data.tripItineraryIsEmpty}
              tripId={tour.data.id}
            />
          </div>
          {Boolean(_.get(tour, 'data.offer')) && (
            <div className={`tour-details-container__content__tabbed__tab`} id="tour-details-banner">
              <DealBanner
                bannerText={_.get(tour, 'data.offer.bannerText')}
                heading={_.get(tour, 'data.offer.descriptionHeading')}
                description={_.get(tour, 'data.offer.description')}
                image={_.get(tour, 'data.offer.image')}
                url={_.get(tour, 'data.offer.url')}
              />
            </div>
          )}
          <div className={`tour-details-container__content__tabbed__tab tab-action-section`} id="tour-details" ref={detailsRef}>
            <TourDetails
              background={tour.data.detailsImage}
              highlights={tour.data.tripHighlights}
              included={tour.data.whatsIncluded}
              isGetaway={tour.data.isGetaway && !isRailBookers()}
            />
          </div>
          <div
            className={`tour-details-container__content__tabbed__tab tab-action-section`}
            id="tour-onboard"
            ref={onboardRef}
          >
            {isRailBookers() && !_.isEmpty(trains) && (
              <TrainsSlider trains={trains} />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TourDetailsContainer
